import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useDispatch,useSelector } from 'react-redux';
import ThemeProvider from '../theme';
import {languagecodevalue} from '../store/reducer'
import { resolveLandingRoute } from '../utils/roleLanding'


const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isLogin = useSelector((state) => state.isLogin);
  const userInfo = useSelector((state) => state.userInfo);

  // Shared resolver - see utils/roleLanding. Returns null for a role we cannot
  // place, in which case stay put rather than bouncing to a learner route that
  // does not exist in this role's tree (the old `else` did, and it looped).
  useEffect(() => {
    if (!isLogin || (pathname !== '/' && pathname !== '/login')) return;
    const target = resolveLandingRoute(userInfo);
    if (!target) return;
    if (target === '/app/course') dispatch(languagecodevalue('en'));
    navigate(target, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider>
      <HeaderStyle>{/* <Logo /> */}</HeaderStyle>
      <Outlet />
    </ThemeProvider>
  );
}
